/**
 * Created by mac on 7/25/18
 */

const MissionIcon = function (mission) {
    const sideBarJson = Missions[mission.type].sideBarJson;
    const sideBarPriority = Missions[mission.type].sideBarPriority;
    const targets = [`mission${mission.type}`];

    if (mission.logic && mission.logic.getTargets) {
        targets.concat(mission.logic.getTargets()); 
    }

    SideBarIcon.call(this, {
        animation: sideBarJson,
        extraBarIcon: Missions[mission.type].extraBarIcon,
        targets,
        progressIconJson: Missions[mission.type].sideBarProgressIconJson,
        control: `${mission.name}MissionIcon`,
        priority: sideBarPriority !== undefined ? sideBarPriority : SideBar.PRIORITY_NORMAL
    });
    this.mission = mission;

    this.resetState();
};

MissionIcon.prototype = Object.create(SideBarIcon.prototype);
MissionIcon.prototype.constructor = MissionIcon;

MissionIcon.prototype.resetState = function () {
    this.available = MissionIcon.IsAvailable(this.mission);

    if (this.available) {
        this.setLocked(false);
        const attention = this.isAttentionRequired();
        this.setAttention(attention);

        this.onUpdateAttentionCounter();

        if (attention) {
            this.mission.logEvent(Mission.EVENTS.MISSION_ATTENTION_ON, { once: true });
        } else {
            this.mission.logEvent(Mission.EVENTS.MISSION_ATTENTION_OFF, { once: true });
        }

        const resultStatus = this.mission.logic && this.mission.logic.calcStatusInfo && this.mission.logic.calcStatusInfo();
        const competitionLeft = this.mission.logic && this.mission.logic.competitionTimeLeft && this.mission.logic.competitionTimeLeft();
        const timeLeft = competitionLeft !== undefined ? competitionLeft : this.mission.getTimeLeft();

        if (this.mission.isCompleted() && (!this.mission.tillTheTimeEnds || timeLeft === 0) || competitionLeft === 0) {
            this.setLeftTime(0);
            this.setTitle(Messages.get("Finished"));
        } else if (resultStatus && resultStatus.sidebarTitle) {
            this.setLeftTime(0);
            this.setTitle(resultStatus.sidebarTitle);
        } else {
            this.setLeftTime(timeLeft);
            this.setTitle(undefined);
        }

        if (resultStatus) {
            this.setDisabled(resultStatus.disabled);
        }

        if (this.mission.logic && this.mission.logic.getSideBarSkin) {
            this.setSkin(this.mission.logic.getSideBarSkin());
        }

        let place = this.mission.getSummary().place;
        place = typeof place === "number" ? (place + 1) : undefined;

        let animationName = resultStatus && resultStatus.animation || "animation";

        const competitionFinished = this.mission.runningCompetition
            && this.mission.runningCompetition.getOutcome() !== Competition.OUTCOME_NONE;

        if (competitionFinished) {
            const win = this.mission.getPrize();
            animationName = win ? "win" : "lose";
            place = Messages.get(win ? "SideBarPlace.Win" : "SideBarPlace.Lose");
        }

        const progress = this.mission.sideBarProgressBar && this.mission.isRunning() && !competitionFinished
            && resultStatus && resultStatus.progressBar && { ...this.mission.sideBarProgressBar, ...resultStatus.progressBar } || undefined;
        this.setProgress(progress);

        if (this.mission.sideBarPlace) {
            this.setPlace(progress ? undefined : place);
        }
        
        this.setAnimation(animationName, resultStatus && resultStatus.transition);
    }
};

MissionIcon.prototype.getLockedTipData = function () {
    if (Missions[this.mission.type].available) {
        return cleverapps.humanReadableNumber({ floatLevel: Missions[this.mission.type].available.level });
    }
};

MissionIcon.prototype.isAttentionRequired = function () {
    if (this.mission.isMinigameMission()) {
        return this.mission.canPlayMinigame();
    }

    if (this.mission.needReview) {
        return true;
    }

    if (this.mission.logic && this.mission.logic.isAttentionRequired) {
        return this.mission.logic.isAttentionRequired();
    }

    if (this.mission.runningCompetition && this.mission.runningCompetition.hasPlaceChanged()) {
        return true;
    }

    return this.mission.type === Mission.TYPE_BONUS_WORLD;
};

MissionIcon.prototype.getAttentionCounter = function () {
    return this.mission.logic && this.mission.logic.getAttentionCounter && this.mission.logic.getAttentionCounter();
};

MissionIcon.prototype.getAttentionCounterFrame = function () {
    return this.mission.logic && this.mission.logic.getAttentionCounterFrame && this.mission.logic.getAttentionCounterFrame();
};

MissionIcon.prototype.getForce = function () {
    return this.mission.iconForce;
};

MissionIcon.prototype.getIncomeIcon = function () {
    return this.mission.logic.getIncomeIcon ? this.mission.logic.getIncomeIcon() : this.mission.getIcon();
};

MissionIcon.prototype.onPressed = function () {
    if (this.mission.logic && this.mission.logic.logEventOnSideBarClick) {
        this.mission.logic.logEventOnSideBarClick();
    }

    if (this.mission.logic && this.mission.logic.onPressed) {
        this.mission.logic.onPressed();
        return;
    }

    const controls = [];
    if (this.mission.logic && this.mission.logic.getControls) {
        controls.push(this.mission.logic.getControls());
    }

    cleverapps.focusManager.display({
        focus: `${this.mission.name}MissionIconClicked`,
        control: controls,
        stack: cleverapps.tutorial.isActive(),
        action: function (f) {
            if (!this.mission.isRunning() && (!this.mission.tillTheTimeEnds || this.mission.getTimeLeft() === 0)) {
                this.mission.displayCompleted(f);
                return;
            }

            const ViewClass = this.mission.getViewClass();
            const view = ViewClass instanceof VirtualJson ? Prefab.instantiate(ViewClass, { args: [this.mission] }) : new ViewClass(this.mission);

            this.mission.skipStartWindow();

            if (ComponentMap.get(view, SceneComponent)) {
                cleverapps.scenes.replaceScene(view, f);
            } else {
                cleverapps.focusManager.onceNoWindowsListener = f;
            }
        }.bind(this)
    });
};

MissionIcon.IsAvailable = function (mission) {
    return MissionManager.hasProperLocation(mission.type) && mission.isAvailable();
};